import React from 'react'
import { useFormContext } from "react-hook-form";
import './../Form.css'

const Dropdown = props => {
    const { validation, options,  action, ...inputProps } = props;
    const { id, label } = inputProps;
    const formBinding = useFormContext();
    const { register,formState: { errors } } = formBinding;
    return (
        <div className="form-element">
            <label>{label}</label>
            <select {...inputProps} {...register(id, validation)} onChange={action}>
                {options.map(({ value, label }) => <option value={value} key={value}>{label}</option>)}
            </select>
            {errors[id] && <p className="input-error">{errors[id].message}</p>}
        </div>
    )
}

export default Dropdown
